import { BANDEIRAS_CARTAO_DELIVERY } from '../../../constants';

export const obterImagemBandeira = (valorBandeira) => {
  const bandeiraAceita = BANDEIRAS_CARTAO_DELIVERY.find(
    ({ valor }) => valor === valorBandeira
  );
  return bandeiraAceita?.imagem;
};
